
export default class TimeSlotModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.start_time = new Date(data.start_time);
    this.end_time = new Date(data.end_time);
  }
}
